export { DMS_MODULE } from '../constants';
export const NAME = 'ExportDat';
export const CRUMB_LABEL_KEY = 'edtDmsExport';
